import React from 'react';
import ProjectLoopLogo from "../../../../images/pl_small_logo.png";
import "./styles.scss";

export default function ParallaxSection() {
    return (
        <div className="Industry-export-section">
            <div className="export-section-content">
                <div className="home-container sl-parallax-container">
                    <div className="export-details">
                        <img src={ProjectLoopLogo} className="logo" />
                        <h2>Designed & Developed By <br />Industry Experts</h2>
                        <p>
                        Built by a team with 100+ years of combined project delivery experience, ProjectLoop was created for project managers by project managers. We listened to the industry and turned those needs into a platform that keeps teams aligned from precon to closeout.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
